var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"title"},[(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(!_vm.title)?_vm._t("title"):_vm._e()],2),_c('div',{staticClass:"controls"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }